import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../assets/css/chat/chatList.css";
import Avatar from "@mui/material/Avatar";
import { wordWrap } from "../../../../utils/helperFunc";

import {
  responsiveUI_userList,
  responsiveUI_chatArea,
} from "../../../../store/slices/chatUi";
import { selectRoom } from "../../../../store/slices/chat";

const ChatListCard = ({ room }) => {
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const chatSocket = useSelector((state) => state.chat.socket);
  const dispatch = useDispatch();
  const selectedRoom = useSelector((state) => state.chat.selectedRoom);

  const mobile_list_hide_action = () => {
    if (viewportWidth <= 720) {
      dispatch(responsiveUI_userList(false));
      dispatch(responsiveUI_chatArea(true));
    }
  };

  const handleSelectedRoom = () => {
    if (selectedRoom?.channel_id !== room?.channel_id) {
      dispatch(selectRoom(room));

      // Join to room
      chatSocket?.send(
        JSON.stringify({
          command: "join",
          room_id: room.channel_id,
        })
      );

      // Read message
      chatSocket?.send(
        JSON.stringify({
          command: "message_read",
          room_id: room.channel_id,
        })
      );
    }
  };

  return (
    <>
      <div
        color="inherit"
        component="div"
        className="theCard"
        onClick={handleSelectedRoom}
      >
        <>
          {room.partner_info?.profile_image ? (
            <Avatar
              className="userImg"
              onClick={mobile_list_hide_action}
              src={room.partner_info?.profile_image}
              alt="user-img"
            />
          ) : (
            <Avatar className="userImg">
              {room.partner_info?.full_name.charAt(0)}
            </Avatar>
          )}
        </>

        <div className="userName" onClick={mobile_list_hide_action}>
          <h1>
            {" "}
            {room?.order_details?.tracking_id
              ? `#Order-${room.order_details.tracking_id}`
              : room.partner_info?.full_name}{" "}
          </h1>
          <p className="last_message">
            {room?.last_msg_send_by === "me"
              ? "You"
              : room?.partner_info?.full_name}
            {": "}
            {wordWrap(room?.last_msg_content, 25)}
          </p>
          <p className="userLastSeen">{room?.last_msg_timesince}</p>
        </div>

        <div className="userUnread">
          {room.unread_message_count > 0 && (
            <p className="userUnreadNum"> {room.unread_message_count} </p>
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(ChatListCard);
